import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { selectCurrentBasketAccounts } from '@epicuro-next/state/basket-state';
import { go } from '@epicuro-next/state/router-store';
import { logout, setFirstLoginAction } from '@epicuro-next/state/user-state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { Severity } from 'graphql-api/baskets-api-interfaces';
import { combineLatest } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';

import { AccountsSelectorComponentStore } from '../../store/accounts-selector.component-store';
import { AccountSelectorBaseComponent } from '../account-selector-base/account-selector-base.component';

@Component({
  selector: 'epc-account-selector-modal',
  templateUrl: './account-selector-modal.component.html',
  styleUrls: ['./account-selector-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AccountsSelectorComponentStore],
  standalone: false,
})
export class AccountSelectorModalComponent
  extends AccountSelectorBaseComponent
  implements OnInit
{
  public isInBasket = false;
  public severity = Severity;
  public addedAddressesCount$ = this.componentStore.addedAddressesCount$;
  public removedAddressesCount$ = this.componentStore.removedAddressesCount$;
  public isActiveAccountChanged$ = this.componentStore.isActiveAccountChanged$;
  public appliedActiveAccount$ = this.componentStore.appliedActiveAccount$;
  public isActiveBasketManipulated$ =
    this.componentStore.isActiveBasketManipulated$;
  public isSelectedAccountHasNoAvailableItemsError$ =
    this.componentStore.isSelectedAccountHasNoAvailableItemsError$;
  public isMoveBasketEnabled$ = this.componentStore.isMoveBasketEnabled$;
  public isMoveBasketFlow$ = this.componentStore.isMoveBasketFlow$;

  public isChangeActiveAccountAlertShown$ = combineLatest([
    this.isActiveAccountChanged$,
    this.isActiveBasketManipulated$,
    this.isSingleSelection$,
  ]).pipe(
    map(
      ([accountChanged, activeBasketManipulated, isSingleSelection]) =>
        accountChanged && activeBasketManipulated && isSingleSelection,
    ),
  );

  constructor(
    store: Store,
    componentStore: AccountsSelectorComponentStore,
    private modal: NgbActiveModal,
  ) {
    super(store, componentStore);
  }

  public ngOnInit() {
    super.ngOnInit();
    this.store
      .pipe(select(selectCurrentBasketAccounts), take(1))
      .subscribe((accounts) =>
        this.componentStore.setInitialSelection(accounts),
      );
    this.closeModal$
      .pipe(takeUntil(this.destroy$), filter(Boolean), take(1))
      .subscribe(() => this.close());
  }

  public handleConfirmAndProceed() {
    if (this.isInBasket) {
      this.updateBasket();
      this.close();
    } else {
      this.confirmInitialSelect();
    }
  }

  public moveBasket() {
    this.componentStore.moveBasket();
  }

  private confirmInitialSelect() {
    this.confirm();
    this.close();
    this.store.dispatch(setFirstLoginAction());
    this.store.dispatch(go({ commands: ['/'] }));
  }

  public close() {
    this.modal.close();
  }

  public handleLogout() {
    this.store.dispatch(logout());
  }
}
